import {Component, Input} from "@angular/core";
import {Promotion} from "@app/core/promotion/domain/dtos/promotion";
import {
    PromotionListTileComponent
} from "@app/presentation/components/promotion-list/promotion-list-tile/promotion-list-tile.component";
import {CommonModule} from "@angular/common";
import {LocalizedRouter} from "@app/presentation/services/localized-router";
import {routesNames} from "@app/app-routing.module";

/**
 * A component that displays a list of promotions.
 */
@Component({
    standalone: true,
    selector: 'app-promotion-list',
    templateUrl: './promotion-list.component.html',
    imports: [
        PromotionListTileComponent,
        CommonModule
    ],
})
export class PromotionListComponent {

    constructor(
       private localizedRouter: LocalizedRouter
    ) {}

    @Input() promotions: Promotion[] = [];

    @Input() navigateOnClick: boolean = false;

    goToPromotionDetail(promotionCode: string): void {
        if (!this.navigateOnClick) {
            return;
        }
        this.localizedRouter.navigate(['/', routesNames.promotionDetail, promotionCode])
    }
}
